import React from 'react'
import { useLocation } from 'react-router-dom'

import url from '@lib/url'

const Canonical = () => {
  const { pathname } = useLocation()

  return <link rel="canonical" href={url.build([location.origin, pathname])} />
}

export default Canonical
